/** Sentinel value for the map campaign filter "all campaigns" overview mode. */
export const ALL_CAMPAIGNS_ID = "__all__";

/** Address feature limit for all-campaigns overview (server allows up to this). */
export const ALL_CAMPAIGNS_ADDRESS_LIMIT = 10000;

export function isAllCampaignsMode(campaignId: string | undefined | null): boolean {
    return campaignId === ALL_CAMPAIGNS_ID;
}

/** True when a specific campaign is selected (not empty, not all-campaigns overview). */
export function isCampaignSelected(campaignId: string | undefined | null): boolean {
    return !!campaignId && !isAllCampaignsMode(campaignId);
}

/** True when the map should load address data (single campaign or all-campaigns overview). */
export function hasMapCampaignScope(campaignId: string | undefined | null): boolean {
    return isCampaignSelected(campaignId) || isAllCampaignsMode(campaignId);
}

import type { AddressFeatureProperties } from "./types";

/** All-campaigns overview: show only delivered addresses that are not blocked or hidden. */
export function isAllCampaignsVisibleAddress(
    properties: AddressFeatureProperties,
    showUndelivered = false
): boolean {
    if (properties.isBlocked || properties.isHidden) {
        return false;
    }
    if (showUndelivered) {
        return true;
    }
    return (properties.flyerStatuses ?? []).some((fs) => fs.deliveredQuantity > 0 || fs.isNoThanks);
}

/** Omit campaignId from API params in all-campaigns overview mode. */
export function resolveMapCampaignIdForApi(campaignId: string | undefined | null): string | undefined {
    if (!campaignId || isAllCampaignsMode(campaignId)) {
        return undefined;
    }
    return campaignId;
}
